// extracted by mini-css-extract-plugin
export default {"button":"kl-z","reviewSort":"ll-z"};